import { render, staticRenderFns } from "./BlogDetailView.vue?vue&type=template&id=8b6bbb16&scoped=true&"
import script from "./BlogDetailView.vue?vue&type=script&lang=js&"
export * from "./BlogDetailView.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetailView.vue?vue&type=style&index=0&id=8b6bbb16&lang=scss&scoped=true&"
import style1 from "./BlogDetailView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6bbb16",
  null
  
)

export default component.exports